export default __webpack_public_path__ + "static/media/storm.8596a268.svg";